"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.CarouselScrollDirection=void 0;var t;(function(e){e.Left="Left",e.Right="Right"})(t||(exports.CarouselScrollDirection=t={}));
//# sourceMappingURL=CarouselScrollDirection.js.map
